import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import { refreshTrueFitWidget } from 'utilities/truefit/truefit';

const TrueFitContainer = styled.div`
  display: flex;
  align-items: center;
  min-height: 56px;
  margin-bottom: var(--spacing-space16);
`;

interface TrueFitWidgetProps {
  itemNumber: string;
  colour: string;
  locale: string;
}

function TrueFitWidget({ itemNumber, colour, locale }: TrueFitWidgetProps) {
  const [userId, setUserId] = useState<string | null>(null);
  const { selectedOptions } = useSelectedSkuContext();
  const { colour: selectedColour } = selectedOptions;

  useEffect(() => {
    setUserId(window?.universal_variable?.user?.user_id);
    refreshTrueFitWidget();
  }, []);

  useEffect(() => {
    if (selectedColour) {
      refreshTrueFitWidget();
    }
  }, [selectedColour]);

  return (
    <TrueFitContainer
      className="tfc-fitrec-product"
      data-styleid={itemNumber}
      data-userid={userId}
      data-colorid={selectedColour || colour}
      data-locale={locale}
      data-testid="truefit_widget_container"
    />
  );
}

export default TrueFitWidget;
